export default __webpack_public_path__ + "static/media/University of Waterloo.8a6ed9a1.png";